import client from './client';

const BASE_URL = '/api/v1/schedule/sales';

/**
 * 직접 등록한 영업 일정.
 *
 * 내가 만든 것과, 같은 부서 사람이 공유한 것이 함께 온다.
 * 기회 · 프로젝트 · 계산서처럼 자동으로 잡히는 일정과는 별개다.
 */
export const getSalesSchedules = (params) => client.get(BASE_URL, { params });

export const addSalesSchedule = (data) => client.post(BASE_URL, data);

export const editSalesSchedule = (schdUuid, data) =>
  client.put(`${BASE_URL}/${schdUuid}`, data);

export const removeSalesSchedule = (schdUuid) =>
  client.delete(`${BASE_URL}/${schdUuid}`);
